module.exports = "ul {\n  list-style-type: none; }\n\n.tableOverride th {\n  color: #4d4d4d;\n  font-family: myriadpro-semibold; }\n\n.tableOverride td {\n  color: #4d4d4d;\n  font-family: myriadpro; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/accountlist.component.scss
// module id = 575
// module chunks = 1